module.exports = __webpack_public_path__ + "img/loginBg.bf1a6c06.jpg";